export const EVENT = {
  name: "Organic Food India Conclave 2026",
  short: "OFIC 2026",
  date: "11 December 2026",
  venue: "Ginger Hotel, Mumbai",
  email: "events@teflas.com",
  phones: ["+91 98338 55566", "+91 98337 55566"],
  organiser: "Tefla's",
  organiserUrl: "https://www.teflas.com",
  address: "301 AB & 308, Abhishek Premises,\nC-5 Dalia Industrial Estate, Off New Link,\nAndheri (W), Mumbai 400053, India.",
  eventStart: "2026-12-11T00:00:00+05:30",
  earlyBirdEnd: "2026-11-10T23:59:59+05:30",
};

export const BROCHURE = "/assets/brochure.pdf";
export const RATECARD = "/assets/ratecard.pdf";

export const WHATSAPP_URL =
  "https://wa.me/919833855566?text=" +
  encodeURIComponent("Hello Tefla's team! I'd like to know more about OFIC 2026 — 11 December, Mumbai.");

export const money = (n, c = "INR") =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: c, maximumFractionDigits: 0 }).format(n);

export const isEarlyBird = () => Date.now() < Date.parse(EVENT.earlyBirdEnd);

export const PACKAGES = [
  {
    id: "delegate",
    tab: "delegate",
    name: "Early bird delegate",
    later: "Standard delegate",
    inr: 7500,
    usd: 600,
    inrLater: 10000,
    usdLater: 1100,
    description: "Participation · Package 1. Connect with the organic food and beverage business ecosystem.",
  },
  {
    id: "stall6",
    tab: "stall",
    name: "6 sq. m exhibition stall",
    inr: 80000,
    usd: 2000,
    description: "A platform to showcase your products, technology and services. Stall allocation subject to availability.",
  },
  {
    id: "stall9",
    tab: "stall",
    name: "9 sq. m exhibition stall",
    inr: 125000,
    usd: 2500,
    description: "Give your business room to connect with buyers and industry partners. Contact Tefla's to confirm availability.",
  },
  {
    id: "corporate",
    tab: "awards",
    name: "Corporates & entrepreneurs",
    inr: 15000,
    usd: 1500,
    description: "Award nomination entry fee and gala dinner only. 11 December 2026 · 7:00 pm onwards.",
  },
  {
    id: "startup",
    tab: "awards",
    name: "Startups & NGOs",
    inr: 11000,
    usd: 2000,
    description: "Award nomination entry fee and gala dinner only. 11 December 2026 · 7:00 pm onwards.",
  },
];

export const PACKAGE_LABELS = {
  delegate: "Delegate participation",
  stall6: "6 sq. m exhibition stall",
  stall9: "9 sq. m exhibition stall",
  corporate: "Awards & gala — Corporates / Entrepreneurs",
  startup: "Awards & gala — Startups / NGOs",
};

export const SCROLL_SECTIONS = [
  ["about", "The conclave"],
  ["why-attend", "Why attend"],
  ["expo", "Expo"],
  ["participants", "Participants"],
  ["participate", "Participation"],
  ["venue", "Venue & contact"],
];
